import { z } from 'zod';
/**
 * Body of `PUT /v1/mcp-connections/:id/scorer-credential`.
 *
 * A scorer credential ("Scorer token" in the console) is a benchmark scoring
 * credential: a second, optional credential on an MCP connection, used ONLY
 * for the server-side run-record fetches of benchmarks whose driver sets
 * `scorecardAuth: 'scorer'` (Start preflight, the sim scorecard, the replay
 * trajectory). It is never handed to an MCP client, so a mission agent
 * driving the connection never holds it. Stored per connection so one secret
 * serves every benchmark on that connection.
 *
 * Why it exists: on the Isaac sim, run records contain the run's answer key,
 * so the sim serves them only to an admin or scorer token, while a mission
 * agent's connection holds the agent token. Benchmarks with `scorecardAuth:
 * 'connection'` (the default; formant-sims uses one token for everything)
 * ignore it and keep using the connection's own Authorization header. Setup:
 * docs/sim-benchmark-connection.md.
 *
 * `authorization` is the full header value. A bare token is stored as
 * `Bearer <token>`.
 */
export const SetMcpScorerCredentialInputSchema = z.object({
    authorization: z.string().trim().min(1).max(8192),
});
/** Whether a scorer credential is stored. Never carries the secret itself. */
export const McpScorerCredentialStatusSchema = z.object({
    mcpConnectionId: z.string(),
    configured: z.boolean(),
    /**
     * GET only: whether the caller may set or remove it (org admin tier: the
     * `fde` role or superuser). Lets the console show the controls read-only.
     */
    canManage: z.boolean().optional(),
});
//# sourceMappingURL=mcp-scorer-credential.js.map